import { GroupNotesModal } from "./GroupNotesModal";

export default GroupNotesModal;
